import React from 'react';
import { Link, useCreatePath } from 'react-admin';

type ResourceLinkProps =
  | React.PropsWithChildren<{
      name: string;
      type?: 'show' | 'edit';
      id: string;
    }>
  | React.PropsWithChildren<{
      name: string;
      type: 'list';
      id?: never;
    }>;

export const ResourceLink: React.FC<ResourceLinkProps> = ({
  name,
  id,
  type = 'show',
  children,
}) => {
  const createPath = useCreatePath();

  return <Link to={createPath({ resource: name, type, id })}>{children}</Link>;
};
